import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { MatIconModule } from '@angular/material/icon';

import { SpecListBlock } from '@core/services/ai/ai-assistant.service';

@Component({
  selector: 'app-ai-spec-list-block',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIconModule],
  template: `
    @if (block.title) {
      <div class="sl__title">{{ block.title }}</div>
    }
    <div class="sl">
      @for (s of block.specs; track s.label) {
        <div class="sl__spec">
          <mat-icon class="sl__icon">{{ s.icon }}</mat-icon>
          <div class="sl__body">
            <div class="sl__value">{{ s.value }}</div>
            <div class="sl__label">{{ s.label }}</div>
          </div>
        </div>
      }
    </div>
  `,
  styles: [
    `
      :host {
        display: block;
      }
      .sl__title {
        font-size: 12px;
        font-weight: 600;
        text-transform: uppercase;
        letter-spacing: 0.04em;
        color: rgba(15, 23, 42, 0.55);
        margin: 0 0 8px;
      }
      .sl {
        background: #fff;
        border: 1px solid rgba(15, 23, 42, 0.08);
        border-radius: 12px;
        padding: 10px 12px;
        display: flex;
        flex-wrap: wrap;
        gap: 12px 20px;
      }
      .sl__spec {
        display: flex;
        align-items: center;
        gap: 8px;
        min-width: 0;
      }
      .sl__icon {
        font-size: 22px;
        width: 22px;
        height: 22px;
        color: #6366f1;
        flex-shrink: 0;
      }
      .sl__body {
        min-width: 0;
      }
      .sl__value {
        font-weight: 700;
        font-size: 14px;
        color: rgba(15, 23, 42, 0.92);
        overflow-wrap: anywhere;
      }
      .sl__label {
        font-size: 11px;
        text-transform: uppercase;
        letter-spacing: 0.04em;
        color: rgba(15, 23, 42, 0.55);
        overflow-wrap: anywhere;
      }
    `
  ]
})
export class AiSpecListBlockComponent {
  @Input({ required: true }) block!: SpecListBlock;
}
